import { CodeNamePair } from '../../model/code-name-pair.model';
import { Resolve, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { ClaimService } from '../../claim.service';

@Injectable()
export class ClaimDataSourcesResolver implements Resolve<CodeNamePair[]> {
  constructor (
    private claimService: ClaimService,
    private router: Router
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CodeNamePair[]> {
    return this.claimService.getClaimDataSources().map(claimDataSources => {
      if (claimDataSources) {
        return claimDataSources;
      } else {
        this.router.navigate(['/']);
        return null;
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-list/resolvers/claim-data-sources.resolver.ts